var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.wxConfigStore.wxready)?_c('span',[_vm._v(_vm._s(_vm.openid))]):_c('span',[_c('ww-open-data',{ref:"open_date",attrs:{"type":"userName","openid":_vm.openid}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }